import * as React from 'react'

import { cn } from '@/lib/utils'

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  labelClass?: string
  isRequired?: boolean
  id: string
  name: string
  value?: string
  handleBlur?: (event: any) => void
  onChange?: (event: any) => void
  touched?: boolean
  error?: string
  labelColor?: string
  errorClass?: string
  hideErrorMsg?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      className,
      label,
      labelClass,
      id,
      name,
      isRequired,
      onChange,
      error,
      value,
      touched,
      handleBlur,
      rows,
      labelColor,
      errorClass,
      hideErrorMsg,
      ...props
    },
    ref
  ) => {
    // console.log(error);
    return (
      <div className='w-full'>
        {label && (
          <label
            htmlFor={label}
            className={cn(
              `block text-xs text-gray-400 mb-1.5 ${
                labelColor ? labelColor : 'text-[#000]'
              } font-normal`,
              labelClass
            )}
          >
            {' '}
            {label}
            {isRequired && (
              <span className='inline-block text-red-400 text-sm pl-1'>*</span>
            )}{' '}
          </label>
        )}
        <textarea
          className={cn(
            'flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm  transition-colors bg-[#F6F8F9] focus-visible:ring-primary placeholder:font-light placeholder:text-sm placeholder:text-#6E7C87 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50 border-[#E5E9EB] placeholder:text-#6E7C87',
            className,
            error &&
              touched &&
              'border-red-500 focus-visible:ring-transparent focus-visible:ring-0'
          )}
          ref={ref}
          rows={rows}
          id={id}
          name={name}
          onChange={onChange}
          value={value}
          onBlur={handleBlur}
          {...props}
          style={{
            resize: 'unset',
          }}
        />
        <span
          className={cn(
            'text-xs text-red-500 hidden',
            error && !hideErrorMsg && 'block',
            errorClass
          )}
        >
          {error && touched && error}
        </span>
      </div>
    )
  }
)
Textarea.displayName = 'Textarea'

export { Textarea }
